/**
 * Inverte o valor booleano de `x`.
 *
 * @param {*} x
 * @returns {boolean}
 */
export function not(x) {
  return !x;
}
